import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { UserForCreateAndModify } from '../../types/users'
import useStyles from './styles/userBasicInfo.styles'

interface UserBasicInfoProps {
  values: UserForCreateAndModify
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<UserForCreateAndModify>
  touched: FormikTouched<UserForCreateAndModify>
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  isSubmitting: boolean
  params: {
    id: string
  }
}

const UserBasicInfo: React.FC<UserBasicInfoProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  params
}) => {
  const classes = useStyles()

  return (
    <div>
      <SectionTitle title={getTranslate('Basic Details')} marginBottom />
      <div className={classes.inputsContainer}>
        <InputWithLabel
          label={getTranslate('Name')}
          placeholder={getTranslate('Enter the user full name')}
          autoComplete="off"
          value={values.name}
          name="name"
          onChange={(event) => setFieldValue('name', event.currentTarget.value)}
          error={(touched.name && !!errors.name) || undefined}
          helpertext={
            touched.name ? getTranslate(errors.name || '') : undefined
          }
          inputSize="small"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          label={getTranslate('Username')}
          placeholder={getTranslate('Enter the username')}
          autoComplete="off"
          value={values.username}
          name="name"
          onChange={(event) =>
            setFieldValue('username', event.currentTarget.value)
          }
          error={(touched.username && !!errors.username) || undefined}
          helpertext={
            touched.username ? getTranslate(errors.username || '') : undefined
          }
          inputSize="small"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          label={getTranslate('Email')}
          placeholder={getTranslate('Enter the user email')}
          type="email"
          name="email"
          autoComplete="off"
          value={values.email}
          onChange={(event) =>
            setFieldValue('email', event.currentTarget.value)
          }
          error={(touched.email && !!errors.email) || undefined}
          helpertext={
            touched.email ? getTranslate(errors.email || '') : undefined
          }
          inputSize="small"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          label={getTranslate('Phone Number')}
          placeholder={getTranslate('Enter the phone number')}
          type="number"
          name="phoneNumber"
          autoComplete="off"
          value={values.phoneNumber}
          onChange={(event) =>
            setFieldValue('phoneNumber', event.currentTarget.value)
          }
          error={(touched.phoneNumber && !!errors.phoneNumber) || undefined}
          helpertext={
            touched.phoneNumber
              ? getTranslate(errors.phoneNumber || '')
              : undefined
          }
          inputSize="small"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          label={getTranslate('Password')}
          placeholder={getTranslate('Enter password')}
          type="password"
          name="password"
          autoComplete="new-password"
          value={values.password}
          onChange={(event) =>
            setFieldValue('password', event.currentTarget.value)
          }
          error={
            (touched.password && !!errors.password) ||
            // (!params.id && !!!values.password) ||
            undefined
          }
          helpertext={
            touched.password
              ? getTranslate(
                  getTranslate(
                    errors.password ||
                      (!params.id && !!!values.password
                        ? 'this field is required'
                        : '')
                  )
                )
              : undefined
          }
          inputSize="small"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>
    </div>
  )
}
export default UserBasicInfo
